export class PasswordConfirnRequest {
    login: string;
    code: string;
    constructor(login: string, code: string) {
        this.login = login;
        this.code = code;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/requests/password-confirm-request.ts